import { Sidebar } from "./Sidebar";

export function Header() {
  return <Sidebar />;
}